<template>
  <div
    class="card"
    @click="$router.push({ name: 'blog-detail', params: { id: content.slug } })"
  >
    <div class="card__image">
      <img src="../assets/images/placeholder-300x202.jpg" alt="" />
    </div>
    <div class="card__content">
      <p class="contafacil">ContaFácil</p>
      <!-- <p>{{ content.id }}</p> -->
      <p class="card__content-text">
        {{
          content.title
            ? content.title
            : "Culpa nulla pariatur exercitation sint eiusmod."
        }}
      </p>
      <p class="card__content-date">{{ date }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    content: {
      type: Object,
      default: function() {
        return {
          img: require("../assets/images/placeholder-300x202.jpg"),
          text: "Amet nostrud quis duis id excepteur.",
          createdAt: new Date(),
          id: "entrada-blog"
        };
      }
    }
  },
  computed: {
    date() {
      return new Date(this.content.createdAt).toLocaleDateString();
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  // border: thin solid #f2f2f2;
  border-radius: 30px;
  overflow: hidden;
  max-width: 300px;
  max-height: 350px;
  margin: 2em auto;
  &__image {
    width: 100%;
    img {
      width: 100%;
      height: auto;
    }
  }
  &__content {
    padding: 1rem 2rem;
    p {
      text-align: start;
      font-size: 14px;
    }
    &-text {
      font-weight: bold;
      margin: 1em 0;
    }
    &-date {
      margin-bottom: 8px;
    }
  }
  // @media (min-width: 1024px){
  //   max-width: 350px;;
  // }
  @media (min-width: 1024px) {
    max-width: 400px;
    max-height: 400px;
    &__content {
      padding: 1rem 2rem;
      p {
        text-align: start;
        font-size: 1.2rem;
        // margin: 1em 0;
      }
      &-text {
        font-weight: bold;
        // font-size: 1.2rem;
      }
      &-date {
        margin-bottom: 16px;
      }
    }
  }
  @media (min-width: 1200px) {
    max-width: 400px;
    max-height: 440px;
    &__content {
      padding: 1rem 2rem;
      p {
        text-align: start;
        font-size: 1.2rem;
        // margin: 1em 0;
      }
      &-text {
        font-weight: bold;
        // font-size: 1.2rem;
      }
      &-date {
        margin-bottom: 16px;
      }
    }
  }
  @media (min-width: 1400px) {
    max-width: 400px;
    &__content {
      padding: 1rem 2rem;
      p {
        text-align: start;
        font-size: 1.2rem;
        // margin: 1em 0;
      }
      &-text {
        font-weight: bold;
        // font-size: 1.2rem;
      }
      &-date {
        margin-bottom: 16px;
      }
    }
  }
  @media (min-width: 1800px) {
    max-width: 400px;
    &__content {
      padding: 1rem 2rem;
      p {
        text-align: start;
        font-size: 1.5rem;
        // margin: 1em 0;
      }
      &-text {
        font-weight: bold;
      }
      &-date {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
